import {
  ApiBaseController,
  AUTH_METHODS,
  SUPPORTED_COOKIE_API_VERSIONS
} from "@fce-bees/fce-common-components";
import { AddressResult } from "src/components/address-section/address-section";
import {
    CreditDecision,
    CreditDecisionResponse,
    MakeCreditDecision,
} from "src/pages/form-page/make-credit-decision/make-credit-decision.types";

const restApiController = new ApiBaseController({
  imsBaseUrl: import.meta.env.VITE_IMS_BASE_URL,
  applicationId: "pre-qualification",
  authMethod: AUTH_METHODS.COOKIE,

});

const graphApiController = new ApiBaseController({
    imsBaseUrl: import.meta.env.VITE_GRAPHQL_BASE_URL,
    applicationId: "pre-qualification",
    authMethod: AUTH_METHODS.COOKIE,
});

const x_region = import.meta.env.VITE_X_REGION;

export const getAddressData = async (postcode: string) => {
  const addresses = await restApiController.authenticatedFetch(
    `${import.meta.env.VITE_LOOKUP_URL}${postcode}`, {
      method: "GET",
      headers: {
        "x-region": x_region,
      },
    },
    SUPPORTED_COOKIE_API_VERSIONS.V1
  );

  return addresses.results as Array<AddressResult>;
};

export const makeCreditDecision = async (correlationId: string, payload: MakeCreditDecision): Promise<CreditDecision> => {
    const resp: CreditDecisionResponse = await graphApiController.authenticatedFetch(import.meta.env.VITE_GRAPHQL_ROUTER_URL,
        {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
                "reference-id": "fce-bees-identity-management-client",
                "x-correlation-id": correlationId,
                "x-region": x_region,
            }
        },
        SUPPORTED_COOKIE_API_VERSIONS.V1
    );
    if (resp.errors?.length > 0) {
        throw new Error("Graph Error: " + JSON.stringify(resp.errors));
    }
    if (!resp.data?.fce?.quote?.fceQuoteSearchCreditDecision) {
        throw new Error("Invalid response: missing credit decision data");
    }
    return resp.data.fce.quote.fceQuoteSearchCreditDecision;
};